import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import SEO from '../SEO/SEO';

const drawerWidthExpanded = 220;
const drawerWidthCollapsed = 70;

const Layout = () => {
  const [expanded, setExpanded] = useState(false);
  const [activeKey, setActiveKey] = useState('Diary');
  const sidebarWidth = expanded ? drawerWidthExpanded : drawerWidthCollapsed;

  return (
    <Box sx={{ display: 'flex', height: "100%", bgcolor: '#F5F7FB', gap:2 }}>
      <SEO title="Dashboard" noindex />
      <Sidebar
        expanded={expanded}
        onToggle={setExpanded}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
      />
      <Box sx={{
        flex: 1,
        marginLeft: `${sidebarWidth}px`,
        transition: 'margin-left 0.2s',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
      }}>
        <Navbar sidebarWidth={sidebarWidth} />
        <Box sx={{ mt: 2, width: '100%' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default Layout;